'use client'

import type { ReactNode } from 'react'

// A definition list (the design system's .ops-fields / .detail-list): mono
// labels in a fixed column, values beside them, hairlines between rows. A
// value that is JSON or a log renders as <pre>. `columns={2}` lays the
// rows out in two columns on wide screens, as the mock's run details do.

export type FieldDef = { label: ReactNode; value: ReactNode; pre?: boolean; wide?: boolean; title?: string }

export function Fields({ fields, columns = 1, labelWidth = 105, className = '' }: { fields: FieldDef[]; columns?: 1 | 2; labelWidth?: number; className?: string }) {
  return (
    <dl className={`m-0 grid gap-x-7 ${columns === 2 ? 'lg:grid-cols-2' : ''} ${className}`}>
      {fields.map((f, i) => (
        <div
          key={i}
          title={f.title}
          className={`grid items-start gap-3 border-b border-border py-[11px] ${f.wide || f.pre ? 'lg:col-span-full' : ''}`}
          style={{ gridTemplateColumns: `${labelWidth}px minmax(0, 1fr)` }}
        >
          <dt className="pt-[2px] font-mono text-micro text-muted-foreground">{f.label}</dt>
          <dd className="m-0 min-w-0 text-small leading-[1.6] text-foreground [overflow-wrap:anywhere]">
            {f.pre ? <pre className="m-0 whitespace-pre-wrap font-mono text-label [overflow-wrap:anywhere]">{f.value}</pre> : (f.value ?? <span className="text-subtle">—</span>)}
          </dd>
        </div>
      ))}
    </dl>
  )
}
